import { render, staticRenderFns } from "./epms2010.vue?vue&type=template&id=0a32d528&scoped=true"
import script from "./epms2010.vue?vue&type=script&lang=js"
export * from "./epms2010.vue?vue&type=script&lang=js"
import style0 from "./epms2010.vue?vue&type=style&index=0&id=0a32d528&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a32d528",
  null
  
)

export default component.exports